import { apolloProvider } from '@/modules/GraphQL';
import { GET_HTML } from '@/graphql/Mystage/material';
import { bizmatesApi } from '@/utils/bizmatesApi';
import logger from '@/modules/Logger';

export const GetHtmlService = {
  // Fetch HTML material from new GraphQL endpoint
  new: async (params, callback) => {
    logger.info(`[Materials][HTML] Fetching HTML from new GraphQL endpoint`, {
      operation: 'materials:get_html'
    });

    const lessonId = params[0].l;
    const rankId = params[0].r;
    const bookingId = params[0].b;
    const studentMaterialId = params[0].sm;
    const client = apolloProvider.defaultClient;

    try {
      const { data } = await client.query({
        query: GET_HTML,
        fetchPolicy: 'no-cache',
        variables: {
          l: parseInt(lessonId),
          r: parseInt(rankId),
          b: parseInt(bookingId),
          sm: parseInt(studentMaterialId)
        }
      });

      if (data?.get_html) {
        callback(data.get_html);
      } else {
        logger.error(`[Materials][HTML] Empty result from HTML GraphQL API`, {
          operation: 'materials:get_html',
          event_type: 4,
          lesson_id: lessonId
        });
      }
    } catch (error) {
      logger.error(`[Materials][HTML] Error fetching HTML material`, {
        error: error.message,
        operation: 'materials:get_html'
      });
      callback(false);
    }
  },

  // Fetch HTML material from legacy REST API
  legacy: async (params, callback) => {
    logger.info(`[Materials][HTML] Fetching HTML from legacy endpoint`, {
      operation: 'materials:get_html'
    });
    
    await bizmatesApi.get(params[1],  { params: params[0] } , (response) => {
      if (response.data) {
        callback(response.data);
      } else {
        logger.error(`[Materials][HTML] Empty result from legacy HTML API`, {
          operation: 'materials:get_html',
          event_type: 4
        });
      }
    });
  }
};
